
import type { BaseErrorResponse, GetCountryListRes, GetCountryRes, GetRegionListRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useCountry() {
  class Country<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Country
     * @name CountryControllerGetCountries
     * @summary Getting a list of countries
     * @request GET:/api3/country
     * @response `200` `GetCountryListRes`
     * @response `400` `BaseErrorResponse`
     */
    countryControllerGetCountries = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCountryListRes, BaseErrorResponse>({
        path: '/api3/country',
        method: 'GET',
        query,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Country
     * @name CountryControllerGetCountry
     * @summary Get country
     * @request GET:/api3/country/{countryId}
     * @response `200` `GetCountryRes`
     * @response `400` `BaseErrorResponse`
     */
    countryControllerGetCountry = (countryId: string, params: RequestParams = {}) =>
      this.request<GetCountryRes, BaseErrorResponse>({
        path: `/api3/country/${countryId}`,
        method: 'GET',
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Country
     * @name CountryControllerGetRegions
     * @summary Getting a list of region
     * @request GET:/api3/country/{countryId}/region
     * @response `200` `GetRegionListRes`
     * @response `400` `BaseErrorResponse`
     */
    countryControllerGetRegions = (
      countryId: string,
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetRegionListRes, BaseErrorResponse>({
        path: `/api3/country/${countryId}/region`,
        method: 'GET',
        query,
        format: 'json',
        ...params,
      });
  }

  return new Country();
}
